import { AxiosError } from 'axios';

// TODO: documentazione
class AxiosHttpError {
  isAxiosHttpError(err: unknown): err is AxiosError {
    return err instanceof AxiosError;
  }

  async parse(error: AxiosError) {
    const { status } = error.response ?? {};
    const data = await error.response?.data;

    const msg = data?.['error']?.message || data?.['message'];

    switch (status) {
      case 500:
        return 'Server non disponibile, riprovare più tardi';
      case 403:
        return 'Permessi insufficienti';
      case 413:
        return `Il file caricato è troppo grande <br> ${msg}`;
      default:
        return msg;
    }
  }
}

export const axiosHttpError = new AxiosHttpError();
